import { render, staticRenderFns } from "./ConfirmNotPublishTemplate.vue?vue&type=template&id=01dda19c&"
import script from "./ConfirmNotPublishTemplate.vue?vue&type=script&lang=js&"
export * from "./ConfirmNotPublishTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports